'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components2 = require('components');

var _reduxModulesCategories = require('redux/modules/categories');

var _reduxModulesPosts = require('redux/modules/posts');

var _reduxModulesSticky = require('redux/modules/sticky');

var _reduxModulesSearch = require('redux/modules/search');

var _reduxAsyncConnect = require('redux-async-connect');

require('../../assets/styles/main.scss');

var _components = {
  _$App: {
    displayName: 'App'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/App/App.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/App/App.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var App = (function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, _App);

    _Component.apply(this, arguments);
  }

  App.prototype.render = function render() {
    var amp = this.props.params.amp;
    var name = this.props.children.props.route.name;

    if (amp) {
      return _react2['default'].createElement(
        'div',
        { className: 'page-wrapper' },
        _react2['default'].createElement(_reactHelmet2['default'], _config2['default'].app.head),
        _react2['default'].createElement(
          'div',
          { className: 'page-main' },
          this.props.children
        )
      );
    }

    return _react2['default'].createElement(
      'div',
      { className: 'page-wrapper page-wrapper--' + name },
      _react2['default'].createElement(_reactHelmet2['default'], _config2['default'].app.head),
      _react2['default'].createElement(_components2.AppSvgIcons, null),
      _react2['default'].createElement(_components2.AppHeader, null),
      _react2['default'].createElement(
        'div',
        { className: 'page-main' },
        this.props.children
      ),
      _react2['default'].createElement(_components2.AppFooter, null)
    );
  };

  _createClass(App, null, [{
    key: 'propTypes',
    value: {
      children: _react.PropTypes.object.isRequired,
      params: _react.PropTypes.object.isRequired,
      route: _react.PropTypes.object
    },
    enumerable: true
  }, {
    key: 'contextTypes',
    value: {
      store: _react.PropTypes.object.isRequired
    },
    enumerable: true
  }]);

  var _App = App;
  App = _wrapComponent('_$App')(App) || App;
  App = _reduxAsyncConnect.asyncConnect([{
    deferred: true,
    promise: function promise(_ref) {
      var _ref$store = _ref.store;
      var dispatch = _ref$store.dispatch;
      var getState = _ref$store.getState;
      var params = _ref.params;

      var promises = [];
      var state = getState();
      var showing = state.posts.showing;
      var categoryId = params.categoryId;

      var categoryName = categoryId ? categoryId : 'all';

      if (!_reduxModulesSticky.isLoaded(state)) {
        promises.push(dispatch(_reduxModulesSticky.load()));
      }

      if (!_reduxModulesCategories.isLoaded(state)) {
        promises.push(dispatch(_reduxModulesCategories.load()));
      }

      if (!_reduxModulesPosts.isLoaded(state, categoryId)) {
        dispatch(_reduxModulesSearch.clearSearch());
        dispatch(_reduxModulesCategories.setActive(categoryName));

        if (categoryId) {
          promises.push(dispatch(_reduxModulesPosts.loadByCategory(categoryId, showing)));
        } else {
          promises.push(dispatch(_reduxModulesPosts.load(showing)));
        }
      }

      return _Promise.all(promises);
    }
  }])(App) || App;
  return App;
})(_react.Component);

exports['default'] = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 674
// module chunks = 0